/* FUEL SHELL - phone capture custom validation.

   RJ, 2026-09-02: "input field for phone number is broken in UI, audit and
   fix it." Part of the fix was layout (assets/fuel-parts.css). This is the
   other part: the native browser validation bubble ("Please fill out this
   field.") that used to fire on submit is un-stylable and un-positionable,
   and on a narrow phone it rendered over the layout instead of near the
   field.

   WHAT THIS DOES
   Finds every phone-capture form named below by its Shopify form id, adds
   `novalidate` at runtime (progressive enhancement: a no-JS submission still
   gets the browser's own native check, never silently accepted), and on
   submit runs the SAME pattern the input already declares in markup - ten
   digits, first digit 6 to 9. A bad number is blocked and a message is
   written into a plain paragraph already sitting in the page (styled with
   the existing .fuel-note--err class, the same one the server round-trip
   error state already uses, so there is one look for "wrong number" rather
   than two).

   SCOPE
   Only the form ids listed in FORM_IDS. Every other contact/customer form
   on the site (there is at least one more phone-capture duplicate inside
   sections/fuel-product.liquid, outside this build's remit, flagged in the
   handoff) is completely untouched by this script.
   ========================================================================== */
(function () {
  'use strict';

  var FORM_IDS = ['fuel-plan-notify'];
  var PATTERN = /^[6-9][0-9]{9}$/;

  function guard(form) {
    if (!form || form.__fuelTelGuarded) return;
    form.__fuelTelGuarded = true;

    var input = form.querySelector('input[type="tel"]');
    var wrap = input && input.closest('.fuel-join--tel');
    var note = form.querySelector('[data-fuel-tel-note]');
    if (!input) return;

    form.setAttribute('novalidate', 'novalidate');

    function clear() {
      if (wrap) wrap.classList.remove('is-invalid');
      input.removeAttribute('aria-invalid');
      if (note) {
        note.textContent = '';
        note.hidden = true;
      }
    }

    function fail(message) {
      if (wrap) wrap.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
      if (note) {
        note.textContent = message;
        note.hidden = false;
      }
    }

    input.addEventListener('input', clear);

    form.addEventListener('submit', function (event) {
      var value = input.value.trim();
      if (PATTERN.test(value)) {
        clear();
        return;
      }
      event.preventDefault();
      fail(
        value === ''
          ? 'Enter your number, ten digits.'
          : 'That does not look like an Indian mobile number.'
      );
      input.focus();
    });
  }

  function init() {
    FORM_IDS.forEach(function (id) {
      guard(document.getElementById(id));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
